import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ParentRelationship,
  AppState,
  AppTypes,
  AppFields,
  take
} from "../../../store";
import { MyProfileDashboardService } from "../../../services";
import { NotificationsService } from "angular2-notifications";
import { Store } from "@ngrx/store";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { EvaluationsService } from "../../../services/evaluations.service";
import * as lodash from "lodash";

@Component({
  selector: "app-evaluation-result",
  templateUrl: "./evaluation-result.component.html",
  styleUrls: ["./evaluation-result.component.css"]
})
export class PlayerEvaluationResultComponent implements OnInit {
  evaluationName: any;
  evaluatorName: any;
  averageScore: any;
  categories: any;
  responses: any;
  filteredResponses: any;
  responsesCopy: any;

  playerID: any;
  userEvaluationID: any;

  playerFullName: any;
  playerAvatar: any;

  selectedCategory = "ALL";
  showCategoryName = true;
  showScoreColumn = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tgsloaderService: Ng4LoadingSpinnerService,
    private notificationsService: NotificationsService,
    private _service: EvaluationsService
  ) {}

  ngOnInit() {
    this.playerID = this.route.snapshot.params.playerID;
    this.userEvaluationID = this.route.snapshot.params.userEvaluationID;
    this.loadEvaluationTemplateResults(this.playerID, this.userEvaluationID);
  }

  showPlayerDashboard() {
    this.router.navigate(["/club-players/" + this.playerID + "/evaluation-info"]);
  }

  loadEvaluationTemplateResults(playerID, userEvaluationID) {
    this.tgsloaderService.show();
    this._service
      .loadEvaluationTemplateResults(playerID, userEvaluationID)
      .subscribe(
        (response: any) => {
          console.log("response = ", response);
          // this.details = response.data;
          this.evaluationName = response.data.evaluationName;
          this.averageScore = response.data.averageScore;
          this.categories = response.data.categories;
          this.playerAvatar = response.data.playerAvatar;
          this.playerFullName = response.data.playerFullName;
          this.responses = response.data.questionResponses;
          this.responsesCopy = this.responses;

          console.log("this.categories => ", this.categories);

          if(this.categories.length > 0){
            this.filterByCategory(
              this.categories[0].categoryID,
              this.categories[0].categoryName,
              this.categories[0].evaluationPresetCategoryID
            );
          }


          this.tgsloaderService.hide();
        },
        error => {
          this.tgsloaderService.hide();
          this.notificationsService.error("Evaluations could not be loaded");
        }
      );
  }

  filterByCategory(categoryID, categoryName, evaluationPresetCategoryID) {
    this.responses = this.responsesCopy;
    this.showScoreColumn = true;

    if (categoryID > 0) {
      this.selectedCategory = categoryName;
      if (evaluationPresetCategoryID === 3) {
        this.showScoreColumn = false;
      }
      this.responses = this.responses.filter(n => n.categoryID == categoryID);
    } else {
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/player/evaluation-result/evaluation-result.component.ts